import { ExclamationCircleIcon } from '@heroicons/react/20/solid'
import { useTranslation } from '@egw/i18n'
import { Button } from '@egw/components'
import { inAppChatService } from '@egw/app-chat'
import { type FC } from 'react'

const DisabledCardSection: FC = () => {
  // -- Hooks ---------------------------------------------------------------
  const { t } = useTranslation('features-account')

  // -- Layout ----------------------------------------------------------------
  return (
    <div className="bg-white">
      <h2 className="mb-4 flex flex-row justify-between">
        <span className="text-xl font-light text-header">{t('debit_card.title')}</span>
        <span className="m-1 flex items-center justify-center rounded-full bg-orange-400 px-2 py-1 text-orange-800">
          <div className="max-w-full flex-initial text-xs leading-none font-bold">{t('debit_card.disabled_chip')}</div>
        </span>
      </h2>
      <div className="flex w-full flex-col rounded-lg bg-orange-50 p-4 md:mb-6 lg:flex-row lg:items-center gap-4">
        <div className="flex items-center flex-col lg:flex-row gap-4">
          <ExclamationCircleIcon className="h-[40px] w-[40px] lg:h-5 lg:w-5 fill-orange-500 grow-0 shrink-0 flex self-start lg:self-center" />
          <span className="flex items-center justify-center text-left text-orange-600">
            {t('debit_card.disabled_card_info')}
          </span>
        </div>
        <Button
          id="callSupport"
          onClick={() => {
            inAppChatService.open()
          }}
        >
          {t('default.contact_client_services')}
        </Button>
      </div>
    </div>
  )
}

export default DisabledCardSection
